import { useEffect } from "react";

const Listing = ({tableColumn, tableRow}) => {
    console.log(tableColumn, "tableColumntableColumntableColumn", tableRow)
    const transformText = (text) => {
        let text_arr = text.split('_')
        // if(text_arr)
        // console.log(css, "csscss")
    return text.split('_').map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  }

  useEffect(()=> {
    // document.querySelectorAll('#myTable th').forEach(cell => {
    //     console.log(cell, "cellcellcell", cell.textContent.includes('comp'))
    //     if (cell.textContent.includes('comp')) {
    //         cell.classList.add('highlight');
    //     }
    // });
  }, [])
  
    return (
        <>
        <div className="table-responsive custom-table compare-csv-table">
                <table className="table table-bordered " id="myTable">
                    <thead>
                        <tr>
                            {tableColumn && tableColumn?.map((item, i) => {
                                let dealName = item.includes('deal_name')
                               return <th key={i} style={{width: dealName ? '300px': '' }}>{transformText(item)}</th>
                            })}
                            
                        </tr>
                    </thead>
                    <>
                        <tbody>
                            {tableRow && tableRow?.map((item, i) => (
                                
                                <tr key={i} className={` ${item.percentage_difference <= 10 ? 'green' : item.percentage_difference <= 40 ? 'yellow' : 'red'} `}>
                                    {tableColumn && tableColumn?.map((key) => {
                                        let dealnamerow = item.deal_name == key
                                        let dealName = key.includes('deal_name')
                                       return <td className="wrap-string" style={{width: dealName ? '300px': '' }}>{item[key]}</td>
                                    })}
                                   
                                </tr>
                            ))}
                            
                        </tbody>                            
                    </>
                </table>
        </div>
        </>
    )
}

export default Listing;